<template>
  <div class="update-page">
    <!-- Header -->
    <div class="page-header">
      <div class="header-inner">
        <button class="back-btn" @click="voltarPerfil">
          <q-icon name="arrow_back" size="18px" />
        </button>
        <div>
          <h1 class="header-title">Actualizar Perfil</h1>
          <p class="header-sub">Mantenha os seus dados sempre actualizados</p>
        </div>
      </div>
    </div>

    <div class="page-body">
      <div class="content-col">
        <div class="form-card">
          <!-- Photo Upload -->
          <div class="photo-section">
            <div class="photo-wrap">
              <q-avatar size="96px" class="user-avatar">
                <img :src="previewFoto || usuario.foto" alt="Foto de perfil" />
              </q-avatar>
              <button type="button" class="camera-btn" @click="selecionarFoto">
                <q-icon name="photo_camera" size="16px" />
              </button>
            </div>
            <div class="photo-meta">
              <div class="photo-hint">Clique na câmera para alterar a foto</div>
              <div class="photo-formats">JPG, PNG · máx. 5 MB</div>
            </div>
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              style="display: none"
              @change="handleFileUpload"
            />
          </div>

          <div class="fields-divider"></div>

          <q-form @submit="salvarDados" class="fields-body">
            <!-- Nome -->
            <div class="field-wrap">
              <label class="field-label">Nome Completo <span class="field-req">*</span></label>
              <q-input
                v-model="usuario.nome"
                outlined
                placeholder="Digite o seu nome completo"
                class="form-input"
                :rules="[
                  val => !!val || 'Nome é obrigatório',
                  val => val.length >= 3 || 'Mínimo 3 caracteres'
                ]"
                lazy-rules
              >
                <template v-slot:prepend>
                  <q-icon name="person" size="18px" />
                </template>
              </q-input>
            </div>

            <!-- Email -->
            <div class="field-wrap">
              <label class="field-label">
                E-mail
                <span class="field-readonly">não editável</span>
              </label>
              <q-input
                v-model="usuario.email"
                outlined
                type="email"
                readonly
                disable
                class="form-input input-disabled"
              >
                <template v-slot:prepend>
                  <q-icon name="mail" size="18px" />
                </template>
                <template v-slot:append>
                  <q-icon name="lock" size="16px" />
                </template>
              </q-input>
            </div>

            <!-- Contacto -->
            <div class="field-wrap">
              <label class="field-label">Contacto <span class="field-req">*</span></label>
              <q-input
                v-model="usuario.contacto"
                outlined
                placeholder="+258 84 123 4567"
                mask="+258 ## ### ####"
                unmasked-value
                class="form-input"
                :rules="[
                  val => !!val || 'Contacto é obrigatório',
                  val => val.length >= 9 || 'Contacto inválido'
                ]"
                lazy-rules
              >
                <template v-slot:prepend>
                  <q-icon name="phone" size="18px" />
                </template>
              </q-input>
            </div>

            <!-- WhatsApp -->
            <div class="field-wrap">
              <label class="field-label">
                WhatsApp
                <span class="field-optional">opcional</span>
              </label>
              <q-input
                v-model="usuario.whatsapp"
                outlined
                placeholder="+258 84 123 4567"
                mask="+258 ## ### ####"
                unmasked-value
                class="form-input"
                hint="Deixe em branco se for igual ao contacto"
                :rules="[val => !val || val.length >= 9 || 'WhatsApp inválido']"
                lazy-rules
              >
                <template v-slot:prepend>
                  <q-icon color="green-7" size="18px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                      <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                    </svg>
                  </q-icon>
                </template>
                <template v-slot:append>
                  <q-btn flat dense icon="content_copy" size="sm" color="grey-5" @click="copiarContacto">
                    <q-tooltip>Copiar do contacto</q-tooltip>
                  </q-btn>
                </template>
              </q-input>
            </div>

            <!-- Buttons -->
            <div class="form-actions">
              <button type="button" class="btn-cancel" @click="cancelar">Cancelar</button>
              <button type="submit" class="btn-save" :disabled="salvando">
                <q-spinner v-if="salvando" size="15px" color="white" class="q-mr-xs" />
                <q-icon v-else name="check" size="16px" class="q-mr-xs" />
                Guardar Alterações
              </button>
            </div>
          </q-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/vuex/store';
import Swal from 'sweetalert2';

const router = useRouter();
const fileInput = ref(null);
const previewFoto = ref(null);
const fotoArquivo = ref(null);
const salvando = ref(false);

const usuario = ref({
  nome: '',
  email: '',
  contacto: '',
  whatsapp: '',
  foto: ''
});

const selecionarFoto = () => {
  fileInput.value.click();
};

onMounted(() => {
  usuario.value = {
    nome: store.state.auth.user.name,
    email: store.state.auth.user.email,
    contacto: store.state.auth.user.phone || '',
    whatsapp: store.state.auth.user.whatsapp || '',
    foto: store.state.auth.user.photo || 'https://amzn-s3-goldenkey.s3.us-east-2.amazonaws.com/properties/icon2.png'
  };
});

const handleFileUpload = (event) => {
  const file = event.target.files[0];
  if (!file) return;
  if (file.size > 5 * 1024 * 1024) return;
  if (!file.type.startsWith('image/')) return;
  fotoArquivo.value = file;
  const reader = new FileReader();
  reader.onload = (e) => { previewFoto.value = e.target.result; };
  reader.readAsDataURL(file);
};

const copiarContacto = () => {
  usuario.value.whatsapp = usuario.value.contacto;
};

const salvarDados = () => {
  salvando.value = true;
  const formData = new FormData();
  formData.append('name', usuario.value.nome);
  formData.append('phone', usuario.value.contacto);
  formData.append('whatsapp', usuario.value.whatsapp || '');
  if (fotoArquivo.value) formData.append('photo', fotoArquivo.value);

  store.dispatch('auth/updateProfile', formData).then(() => {
    salvando.value = false;
    Swal.fire({
      title: 'Sucesso!',
      text: 'Perfil actualizado com sucesso.',
      icon: 'success',
      confirmButtonText: 'OK'
    }).then(() => { router.push('/profile'); });
  }).catch(err => {
    salvando.value = false;
    console.error(err);
    Swal.fire({
      title: 'Erro!',
      text: 'Houve um problema ao actualizar o perfil. Tente novamente.',
      icon: 'error',
      confirmButtonText: 'OK'
    });
  });
};

const cancelar = () => { router.push('/profile'); };
const voltarPerfil = () => { cancelar(); };
</script>

<style scoped>
.update-page {
  min-height: 100vh;
  background: #f4f6fb;
}

/* ── Header ── */
.page-header {
  background: #0d1b2a;
  padding: 28px 24px;
  border-bottom: 1px solid rgba(212, 175, 55, 0.15);
}
.header-inner {
  max-width: 580px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
}
.back-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: rgba(255, 255, 255, 0.12); }
.header-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 3px;
}
.header-sub {
  font-size: 12.5px;
  color: rgba(212, 175, 55, 0.7);
  margin: 0;
  letter-spacing: 0.3px;
}

/* ── Body ── */
.page-body {
  display: flex;
  justify-content: center;
  padding: 28px 16px 48px;
}
.content-col { width: 100%; max-width: 560px; }

/* ── Form Card ── */
.form-card {
  background: #ffffff;
  border: 1px solid #e8ecf4;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 2px 16px rgba(13, 27, 42, 0.07);
}

/* ── Photo Section ── */
.photo-section {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 28px 24px;
}
.photo-wrap { position: relative; flex-shrink: 0; }
.user-avatar {
  background: rgba(212, 175, 55, 0.1);
  color: #d4af37;
  border: 3px solid rgba(212, 175, 55, 0.25);
  border-radius: 50%;
}
.camera-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: #0d1b2a;
  color: #d4af37;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}
.camera-btn:hover { background: #d4af37; color: #0d1b2a; }
.photo-meta { flex: 1; }
.photo-hint { font-size: 13px; color: #374151; font-weight: 500; margin-bottom: 3px; }
.photo-formats { font-size: 12px; color: #9ca3af; }

.fields-divider { height: 1px; background: #f0f2f7; }

/* ── Fields ── */
.fields-body { padding: 24px 28px 28px; display: flex; flex-direction: column; gap: 4px; }
.field-wrap { margin-bottom: 4px; }
.field-label {
  display: block;
  font-size: 12.5px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  letter-spacing: 0.2px;
}
.field-req { color: #dc2626; margin-left: 2px; }
.field-optional {
  display: inline-block;
  margin-left: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
  background: #f3f4f6;
  border-radius: 4px;
  padding: 1px 6px;
  vertical-align: middle;
}
.field-readonly {
  display: inline-block;
  margin-left: 6px;
  font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
  background: #f3f4f6;
  border-radius: 4px;
  padding: 1px 6px;
  vertical-align: middle;
}

:deep(.form-input .q-field__control) {
  border-radius: 11px !important;
  background: #fafbfc !important;
}
:deep(.form-input.q-field--focused .q-field__control) {
  border-color: #d4af37 !important;
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.12);
}
:deep(.input-disabled .q-field__control) {
  background: #f3f4f6 !important;
  opacity: 1 !important;
}

/* ── Buttons ── */
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}
.btn-cancel {
  flex: 1;
  padding: 12px 20px;
  border-radius: 11px;
  border: 1px solid #d1d5db;
  background: transparent;
  color: #6b7280;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-cancel:hover { background: #f3f4f6; }
.btn-save {
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 11px;
  border: none;
  background: #0d1b2a;
  color: #d4af37;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: background 0.15s, opacity 0.15s;
}
.btn-save:hover { background: #162940; }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
